export class CategoryFieldDateReq {
    categoryKey:  string;
    date: string;
    clientCode: string;
    divisionId:number;
}